import { useAppSelector } from "../../store/hooks";
import type { OrderedItem } from "../../api/reports";

// i18n ключовете на вида ред в справката „Асортименти"/„Рецепти" (колоната
// „Тип", филтъра и Excel експорта). Продаваемото НЕ се казва „Продукт" — то е
// „Асортимент", а в режим „със склад" (organizations.uses_warehouse, идва от
// GET /user/info) е „Рецепта". Двойник на `useAssortmentReportTitleKey` —
// същото разклонение по терминология, ново място минава оттук.
export const useOrderedItemKindKeys = () => {
  const usesWarehouse = useAppSelector(
    (s) => s.auth.user?.uses_warehouse === true,
  );

  const addonKey = "reportsPage.assortmentKindAddon";
  const sellableKey = usesWarehouse
    ? "reportsPage.assortmentKindRecipe"
    : "reportsPage.assortmentKindAssortment";

  const lunchKey = "reportsPage.assortmentKindLunch";

  return {
    addonKey,
    sellableKey,
    lunchKey,
    keyOf: (row: OrderedItem): string =>
      row.is_addon ? addonKey : row.is_lunch ? lunchKey : sellableKey,
  };
};
